import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsTemplate({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4.4A1.8 1.8 0 108 .8a1.8 1.8 0 000 3.6zM5 4a.75.75 0 10-.86-1.24A6.75 6.75 0 001.3 7.57a.75.75 0 101.49.16C2.95 6.2 3.78 4.83 5 4zm6.86-1.24A.75.75 0 0011 3.99a5.25 5.25 0 012.22 3.74.75.75 0 101.5-.16c-.22-2-1.3-3.72-2.86-4.81zm-6.3 10.2a.75.75 0 10-.69 1.32 6.72 6.72 0 006.26 0 .75.75 0 00-.7-1.33 5.22 5.22 0 01-4.86 0zm-.96-1.81a1.8 1.8 0 11-3.6 0 1.8 1.8 0 013.6 0zm8.6 1.8a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z"
      />
    </svg>
  );
}

SvgSettingsTemplate.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsTemplate.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsTemplate svgRef={ref} {...props} />
));
export default ForwardRef;
